<template>
    <div class="non-perceptual-security-system">
        <Row>
            <Col>
                <div class="core-title">产品概述</div>
            </Col>
        </Row>
        <Row type="flex" justify="space-around" align="middle">
            <Col span="10">
                <div class="core-text">
                    在社区、楼宇、办公场所中，其视频监控系统、门禁系统、访客系统、报警系统互相独立，成为信息孤岛，效率低下。本系统以人脸为轴，将门禁、访客、监控、报警这四个孤立的系统，进行了高度整合。使门禁做到无感知的自动开门，访客进行自动登记、授权、回收，全程监控并且轨迹可寻可查可分析，自动基防报警（比如在入口处未发现的人员，在楼栋内部出现，则具有非法入侵的嫌疑）等。
                </div>
            </Col>
            <Col span="8">
                <div class="core-img">
                    <img src="@/images/core/community.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">行业分析</div>
            </Col>
        </Row>
        <Row type="flex" justify="center" align="middle">
            <Col span="9">
                <div class="core-img">
                    <img src="@/images/core/searchVideo.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                </div>
            </Col>
            <Col span="3">
                <img src="@/images/core/leftLine.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
            </Col>
            <Col span="5">
                <div class="core-card">
                    <div class="core-card-title">
                        <img src="@/images/core/monitor.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        <span>监控系统</span>
                    </div>
                    <ul>
                        <li>用作被动的事后取证，利用率低，调阅取证效率低下</li>
                        <li>无法及时有效地进行</li>
                    </ul>
                </div>
            </Col>
        </Row>
        <Row type="flex" justify="center" align="middle">
            <Col span="5">
                <div class="core-card">
                    <div class="core-card-title">
                        <img src="@/images/core/entrance.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        <span>门禁系统</span>
                    </div>
                    <ul>
                        <li>门卡、指纹、闸机，不方便，有延时</li>
                        <li>门卫/保安手动登记，不便于管理</li>
                    </ul>
                </div>
            </Col>
            <Col span="3">
                <img src="@/images/core/rightLine.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
            </Col>
            <Col span="9">
                <div class="core-img" style="background-color: rgba(0,0,0,0.2)">
                    <img src="@/images/core/entranceGuard.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">解决方案</div>
            </Col>
        </Row>
        <Row class="solution">
            <Col class="core-content">
                <div style="width: 100%">
                    <div class="solution-process">
                        <div class="process-item">
                            <div class="process-point">
                                <img src="@/images/core/face.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                                <p>人脸门禁</p>
                            </div>
                            <div class="process-detail">
                                <p>业主人脸识别</p>
                                <p>无感知进入</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/images/core/arrowRight.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        </div>
                        <div class="process-item">
                            <div class="process-point">
                                <img src="@/images/core/authorize.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                                <p>访客授权</p>
                            </div>
                            <div class="process-detail">
                                <p>访客身份登记</p>
                                <p>限时出入，轨迹记录</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/images/core/arrowRight.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        </div>
                        <div class="process-item">
                            <div class="process-point">
                                <img src="@/images/core/alarm.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                                <p>实时告警</p>
                            </div>
                            <div class="process-detail">
                                <p>可疑人物，异常进入</p>
                                <p>主动预警，实时报警</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/images/core/arrowRight.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        </div>
                        <div class="process-item">
                            <div class="process-point">
                                <img src="@/images/core/trajectoryAnalysis.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                                <p>轨迹追踪</p>
                            </div>
                            <div class="process-detail">
                                <p>实时告警轨迹分析</p>
                                <p>以图搜人，查询历史轨迹</p>
                            </div>
                        </div>
                        <div>
                            <img src="@/images/core/arrowRight.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        </div>
                        <div class="process-item">
                            <div class="process-point">
                                <img src="@/images/core/data.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                                <p>大数据分析</p>
                            </div>
                            <div class="process-detail">
                                <p>记录历史核心数据</p>
                                <p>大数据分析</p>
                            </div>
                        </div>
                    </div>
                    <div class="solution-system">
                        <img src="@/images/core/intelligentCommunity.png" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                        <div class="system-detail" style="top: 0;">
                            <div class="core-card">
                                <div class="core-card-title">人流量统计</div>
                                <p>异常人员告警统计</p>
                            </div>
                        </div>
                        <div class="system-detail" style="top: 0;right: 0;">
                            <div class="core-card">
                                <div class="core-card-title">告警列表</div>
                                <p>实时弹出告警人员列表详情</p>
                            </div>
                        </div>
                        <div class="system-detail" style="top: 190px;">
                            <div class="core-card">
                                <div class="core-card-title">流量热力图</div>
                                <p>反映人流量大小及告警高频区域</p>
                            </div>
                        </div>
                        <div class="system-detail" style="right: 0;top: 190px;">
                            <div class="core-card">
                                <div class="core-card-title">小区数据</div>
                                <p>男女比例、年龄分布、房屋空置率</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                <div class="core-title">应用领域</div>
            </Col>
        </Row>
        <Row class="core-applications core-content">
            <Col style="width: 100%">
                <Row type="flex" justify="space-around">
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-community.jpg" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                            </div>
                            <div class="title"><span>--</span>住宅小区<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-hospital.jpg" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                            </div>
                            <div class="title"><span>--</span>医院<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-building.jpg" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                            </div>
                            <div class="title"><span>--</span>写字楼<span>--</span></div>
                        </div>
                    </Col>
                    <Col span="5">
                        <div class="application">
                            <div class="img">
                                <img src="@/images/core/app-school.jpg" alt="无感知智慧社区/办公/楼宇安全卫士系统">
                            </div>
                            <div class="title"><span>--</span>学校<span>--</span></div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    </div>
</template>

<script>
export default {
  name: 'non-perceptual-security-system'
};
</script>

<style lang="less">
    .non-perceptual-security-system {
        .core-img {
            margin: 20px 0;
        }
        .solution {
            background: url("~@/images/core/communitySolutionBg.png") 0 e('/') 100% no-repeat;
            .solution-process {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 40px 20px;
            }
            .process-point{
                width: 120px;
                height: 120px;
                background: url("~@/images/core/solutionBg.png") 0 e('/') 100% no-repeat;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                img{
                    width: 35px;
                }
                p{
                    font-size: 16px;
                }
            }
            .process-detail {
                text-align: center;
            }
            .solution-system {
                text-align: center;
                position: relative;
                img {
                    width: 750px;
                }
                .system-detail {
                    position: absolute;
                    width: 165px;
                }
            }
        }
    }
</style>
